<template>
    <div class="import-contacts-wrapper importContactsFromCSVButton">
        <action-modal
                :headline="heading"
                :button-label="'Import contacts from CSV'"
                button-type="warning"
                :action-button-styles="true"
                :take-action-function="handleImport"
                :action-button-hidden="actionButtonHidden"
                :redirect-url="redirectUrl"
                @close-modal="onCloseModal"
        >
            <slot>
                <input class="hidden" type="file" ref="csv" v-on:change="uploadFile()">
                <div v-if="!fileSelected" class="wrapper">
                    <div class="button-wrapper">
                        <button @click="$refs.csv.click()" class="actionButton">
                            Select File
                        </button>
                    </div>
                </div>
                <div v-if="fileSelected" class="container">
                    <div class="row">
                        <div class="col-sm-8 col-sm-offset-2">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="left">CSV Column</th>
                                        <th class="middle"></th>
                                        <th class="right">Contact Field</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(headerColumnTitle, headerColumnIndex) in header">
                                        <td class="left">
                                            {{ headerColumnTitle }}<br />
                                            <small><i>Sample: {{ firstRow[headerColumnIndex] }}</i></small>
                                        </td>
                                        <td class="middle">
                                            =
                                        </td>
                                        <td class="right">
                                            <select @change="updateMapping($event, headerColumnIndex)">
                                                <option selected value="ignore">Do Not Import</option>
                                                <option value="ignore">--------------------</option>
                                                <option v-for="field in fieldsToMap" v-bind:value="field.key" :disabled="field.selected !== null">{{ field.label }}</option>
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="touched && missingFieldNames.length" class="required-fields-message">
                                Please make sure these required fields are mapped and try again:<br/>
                                {{ missingFieldNames.map(field => toTitleCase(field)).join(', ') }}
                            </div>
                        </div>
                    </div>
                </div>
            </slot>
        </action-modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import {VTooltip} from "v-tooltip";
    import Papa from 'papaparse';
    import ActionModal from "./ActionModal";

    export default {
        name: 'import-contacts',
        components: { ActionModal, Papa, VTooltip },
        data() {
            return {
                fieldsToMap: [
                    { 'key': 'salutations', 'label': 'Salutations', 'selected': null },
                    { 'key': 'first name', 'label': 'First Name', 'selected': null },
                    { 'key': 'middle name', 'label': 'Middle Name', 'selected': null },
                    { 'key': 'last name', 'label': 'Last Name', 'selected': null },
                    { 'key': 'designations', 'label': 'Designations', 'selected': null },
                    { 'key': 'email address', 'label': 'Email Address', 'selected': null },
                    { 'key': 'phone number', 'label': 'Phone Number', 'selected': null },
                    { 'key': 'address', 'label': 'Street Address', 'selected': null },
                    { 'key': 'address 2', 'label': 'Street Address 2', 'selected': null },
                    { 'key': 'city', 'label': 'City', 'selected': null },
                    { 'key': 'state', 'label': 'State', 'selected': null },
                    { 'key': 'zip', 'label': 'Zip', 'selected': null },
                    { 'key': 'website', 'label': 'Website', 'selected': null },
                ],
                heading: "Select the CSV of contacts to import",
                fileSelected: false,
                actionButtonHidden: true,
                csv: null,
                header: null,
                firstRow: null,
                requiredFieldNames: [
                        'first name',
                        'last name',
                        'email address'
                ],
                touched: false
            }
        },
        computed: {
            mappedFields() {
                return this.fieldsToMap.reduce((tempMappedFields, field) => {
                    if (field.selected !== null) {
                        tempMappedFields.push({
                            'key': field.key,
                            'selected': field.selected
                        });
                    }
                    return tempMappedFields;
                }, []);
            },
            mappedFieldNames() {
                return this.mappedFields.map(field => field.key);
            },
            missingFieldNames() {
                return this.requiredFieldNames.filter(required => !this.mappedFieldNames.includes(required));
            }
        },
        methods: {
            uploadFile() {
                const self = this;
                const reader = new FileReader();

                self.csv = self.$refs.csv.files[0];
                reader.readAsText(self.csv, "UTF-8");

                reader.onload = function (evt) {
                    const data = Papa.parse(evt.target.result, { preview: 2 }).data;
                    self.header = data[0];
                    self.firstRow = data[1];
                };

                self.fileSelected = true;
                self.actionButtonHidden = false;
                self.heading = "Please map the CSV columns with the appropriate contact fields:";
            },
            updateMapping(event, headerColumnIndex) {
                const selectedValue = event.target.value;

                if (selectedValue === 'ignore') {
                    let field = this.fieldsToMap.find(field => { return field.selected === headerColumnIndex; });

                    if (field) {
                        field.selected = null;
                    }
                    return;
                }

                this.fieldsToMap.forEach(field => {
                    if (field.selected === headerColumnIndex) {
                        field.selected = null;
                    }
                });

                let field = this.fieldsToMap.find(field => { return field.key === selectedValue; });
                field.selected = headerColumnIndex;
            },
            handleImport() {
                this.touched = true;

                if( this.missingFieldNames.length ) {
                    return;
                }

                if(!confirm('Are you sure you want to import all of the contacts in this csv?') ) {
                    this.$emit('close-modal');
                    return;
                }

                this.$emit('close-modal');
                this.$emit('action-processing', {
                    'type': 'csv-import'
                });

                const formData = new FormData();
                formData.append('file', this.csv);

                this.mappedFields.forEach(field => {
                    formData.append('header[' + field.selected + ']', field.key);
                });

                axios.post(this.postUrl, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then( () => {
                    this.$emit('close-modal');
                    $.notify("Redirecting...", "success");

                    setTimeout( () => {
                        window.location = this.redirectUrl;
                    },2000);
                });
            },
            toTitleCase(str) {
                return str.replace(/\w\S*/g, function(txt){
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            },
            onCloseModal() {
                this.$emit('close-modal');
            }
        },
        props: {
            postUrl: {
                type: String,
                required: true
            },
            redirectUrl: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="scss">
    .import-contacts-wrapper {

        .modal-action-button{

            margin-bottom: 80px;
        }

        th{
            &.left{
                border-top-left-radius:4px;
                width: 45%;
                text-align: right;
            }
            &.middle{
                width: 10%;
            }
            &.right{
                border-top-right-radius:4px;
                width: 45%;
                text-align: left;
            }        
        }

        td{
            &.left{
                width: 45%;
                text-align: right;
            }
            &.middle{
                width: 10%;
                line-height: 1.5;
                font-size: 175%;
                color: #999999;
                text-align: center;
            }
            &.right{
                width: 45%;
                text-align: left;
            }
        }
    }

    .required-fields-message {
        font-size:18px;
        color:red;
    }
</style>
